/***************************************************
 * Velja viðeigandi link m.v hvað er verið að gera *
 ****************************************************/

export const fetchlink = 'https://api.kjarasamningar.is';
// export const fetchlink = 'http://localhost:5000';
